import React, { useRef } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { formatRackLocationLabel } from "src/utils/rackLocations";

export default function RackLocationsComponent({ entity }) {
  const rackLocations = entity.rackLocations || [];
  const ref = useRef();

  const handleClick = () => {
    const event = new MouseEvent("dblclick", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    ref.current.parentElement.dispatchEvent(event);
  };

  return (
    <>
      <Box
        ref={ref}
        width="100%"
        height="100%"
        minHeight={18}
        overflow="auto"
        onClick={handleClick}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="flex-start"
        sx={{ overflowX: "hidden" }}
      >
        {rackLocations.map((v, i) => (
          <Typography key={i} fontSize="0.875rem">
            {formatRackLocationLabel(v, { includeQty: true })}
          </Typography>
        ))}
      </Box>
    </>
  );
}
